import React, { useEffect } from 'react';
import { setRates, salariedRentByWage, salariedAnualRent, freelancerMonthlyRate, freelancerAnualRent, salariedAndFreelances, salariedAndSalaried, formatNumber, currentSalariedAndFreelances, currentSalariedAndSalaried } from '../../utils/functions';

const Results = ({ person, settings }) => {

    window.dataLayer = window.dataLayer || [];

    useEffect(() => {
        //  Se envia evento para notificar que esta pregunta se desplego
        window.dataLayer.push({
            'event': 'ev_view_screen',
            'data': {
                'screen': {
                    'id': 'resultado',
                    'name': 'resulatdo',
                }
            }
        });

    }, []);


    const getResults = () => {
        setRates(settings.rates);
        var results = {};

        switch (person.contribuyente) {
            case 'asalariado': results = { current: salariedRentByWage(person), new: salariedAnualRent(person) }; break;
            case 'independiente': results = { current: freelancerMonthlyRate(person), new: freelancerAnualRent(person) }; break;
            case 'ambas': results = { current: currentSalariedAndFreelances(person), new: salariedAndFreelances(person) }; break;
            case 'ambasymas': results = { current: currentSalariedAndSalaried(person), new: salariedAndSalaried(person) }; break;
        }

        return <>
            <div className="containerResults">
                <div className="divisionResults">
                    <p className="resultHeadline">Mensual</p>
                    <p className="resultData">Sin reforma:<strong>&nbsp;{formatNumber(Math.round(results.current / 12))}</strong></p>
                    <p className="resultData">Con reforma:<strong>&nbsp;{formatNumber(Math.round(results.new / 12))}</strong></p>
                    <p className="resultData">Diferencia:<strong>&nbsp;{formatNumber(Math.round((results.new / 12) - (results.current / 12)))}</strong></p>
                </div>
                <div className="divisionResults">
                    <p className="resultHeadline">Anual</p>
                    <p className="resultData"><strong>{formatNumber(Math.round(results.current))}</strong></p>
                    <p className="resultData"><strong>{formatNumber(Math.round(results.new))}</strong></p>
                    <p className="resultData"><strong>{formatNumber(Math.round(results.new - results.current))}</strong></p>
                </div>
            </div>
            <div className="containerResults" style={{ marginTop: '0px' }}>
                <p className="resultData" style={{ borderBottom: '0px' }}>Diferencia porcentual:<strong>&nbsp;{results.current > 0 ? Math.round((results.new - results.current) * 100 / results.current) : 100}%</strong></p>
            </div>
        </>
    }

    return <div id="results">
        <div className="questionsContent">
            <p className="resultTittle">
                Resultado
                <div className="tooltip">
                    <img src="https://www.nacion.com/gnfactory/especiales/2021/calculadora-renta-global-dual/images/question_calc.svg" style={{ margin: '0px 0px -2px 6px', cursor: 'pointer' }} />
                    <span className="tooltiptext">Los resultados son solo de referencia y pueden variar dependiendo de múltiples factores, tanto personales como por cambios potenciales a las normas fiscales aplicables.</span>
                </div>
            </p>
            <span className="details">Según los datos ingresados, este es el monto por impuesto sobre la Renta Global Dual que tendría que pagar:</span>
            {getResults()}
        </div>
        {person.conyuge === 'si' &&
            <div className="disclaimer">*El cálculo del pago con reforma es bajo el supuesto de que el cónyuge no haya aplicado ninguno de los créditos familiares.</div>
        }
    </div>;
};

export default Results;